import { ECategory } from 'v2/resources/types/files';
import * as Yup from 'yup';

export const schemaAddFiles = (isEditing: boolean) =>
  Yup.object().shape({
    title: Yup.string().required('Título é obrigatório'),
    description: Yup.string().required('Descrição é obrigatória'),
    category: Yup.mixed()
      .oneOf(Object.values(ECategory))
      .required('Categoria é obrigatória')
      .test('test-category', 'Categoria é inválida', (value) => {
        return value !== ECategory.SELECT_CATEGORY;
      }),
    file: Yup.mixed().when([], {
      is: () => isEditing,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('Arquivo é obrigatório'),
    }),
  });
